var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleGLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.174,
    height: 24.174,
    viewBox: "0 0 24.174 24.174",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Google__G__logo",
    transform: "translate(-1 -1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2489",
    "data-name": "Path 2489",
    d: "M23.6,12.472A13.888,13.888,0,0,0,23.384,10H12v4.681h6.5a5.573,5.573,0,0,1-2.428,3.637v3.044H20a11.809,11.809,0,0,0,3.6-8.889Z",
    transform: "translate(1.087 0.889)",
    fill: "#4285f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2490",
    "data-name": "Path 2490",
    d: "M12.97,23.879a11.536,11.536,0,0,0,8-2.923l-3.923-3.044A7.267,7.267,0,0,1,6.2,14.1H2.18v3.121A12.076,12.076,0,0,0,12.97,23.879Z",
    transform: "translate(0.117 1.294)",
    fill: "#34a853"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2491",
    "data-name": "Path 2491",
    d: "M6.318,14.784a7.049,7.049,0,0,1,0-4.593V7.07H2.3A11.965,11.965,0,0,0,2.3,17.9l3.132-2.439.89-.681Z",
    transform: "translate(0 0.6)",
    fill: "#fbbc05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2492",
    "data-name": "Path 2492",
    d: "M12.97,5.813a6.6,6.6,0,0,1,4.626,1.8l3.461-3.461A11.6,11.6,0,0,0,12.97,1,12.066,12.066,0,0,0,2.18,7.67L6.2,10.79A7.216,7.216,0,0,1,12.97,5.813Z",
    transform: "translate(0.117 0)",
    fill: "#ea4335"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2493",
    "data-name": "Path 2493",
    d: "M1,1H25.174V25.174H1Z",
    transform: "translate(0 0)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleGLogo);
export default __webpack_public_path__ + "static/media/Google_G_Logo.dcd0e86a9fe2987690015d17c7051f31.svg";
export { ForwardRef as ReactComponent };